import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {NgxStripeModule} from 'ngx-stripe';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import {MatGoogleMapsAutocompleteModule} from '@angular-material-extensions/google-maps-autocomplete';
import {AgmCoreModule} from '@agm/core';
import {ToastrModule} from 'ngx-toastr';

const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(), // ToastrModule added

        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        LeafletModule,
        NgxStripeModule.forRoot('pk_test_51KvFczIF0pHJMxntLQe6mHt1RPg82BCzh8AfuEynDfsaC5OTIb05D5IgXC7h9tcGH1ocYvk796APxvdL7kvcuVok00RPI8epEP'),
        NgxGoogleAnalyticsModule.forRoot('G-1HT68N1CW0'),
        NgxGoogleAnalyticsRouterModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDyIx2FL1ZPd8LUYDieGZNcmOnO_aCAvps',
            libraries: ['places', 'geometry'],
            apiVersion: '4',
            language: 'cs'
        }),
        MatGoogleMapsAutocompleteModule,
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
